import {
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import SelectAutocomplete from '../../../../widgets/SelectAutocomplete';
import { allUsuariosAction } from '../UsuariosAction';

const SelectFieldUsuariosComponent = ({
  onChange,
  data,
  value,
  required = false,
  selects = [],
  isAutoComplete,
  notEntidad = false,
  rol,
}) => {
  const dispatch = Redux.useDispatch();

  const usuariosStore = Redux.useSelector((state) => state.usuarios);

  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      if (!data) {
        await allUsuariosAction(dispatch, {
          rol,
        });
        setItems(usuariosStore.all);
      }

      if (usuariosStore.all.length > 0 && notEntidad) {
        const list = usuariosStore.all.filter(
          (el) => el.entidades.length === 0,
        );
        setItems(list);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handlerSelects = () => {
    let items = [];
    if (selects.length > 0) {
      usuariosStore.all.forEach((se) => {
        const existSeletc = selects.some((item) => item.id === se.id);
        if (!existSeletc) items.push(se);
      });
      setItems(items);
    } else {
      if (data) setItems(data);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => _handlerSelects(), [selects]);

  const select = (
    <FormControl fullWidth size="small" required={required}>
      <InputLabel id={`label_${CONST.usuario.name}`}>
        {CONST.usuario.label}
      </InputLabel>
      <Select
        id={CONST.usuario.name}
        value={value}
        labelId={`label_${CONST.usuario.name}`}
        label={CONST.usuario.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {items.map((el, index) => {
          return (
            <MenuItem key={`usuario-${index}`} value={el.id}>
              {`${el.perfil.pnombre} ${el.perfil.papellido}`.toUpperCase()}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );

  const autoComplete = (
    <SelectAutocomplete
      id="combo-box-demo-usuarios"
      opt={items}
      type={CONST.usuario.name}
      onChange={(_, newValue) => onChange(newValue?.id)}
      l={CONST.usuario.label}
    />
  );

  return (
    <Stack>
      {usuariosStore.loadingAll && (
        <CircularProgress sx={{ color: 'white' }} size={50} thickness={5} />
      )}
      {isAutoComplete ? autoComplete : select}
    </Stack>
  );
};

export default SelectFieldUsuariosComponent;
